import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { ArrowLeft, Briefcase, Loader2 } from "lucide-react";
import PaydayCard from "@/components/prohub/PaydayCard";
import BillsCard from "@/components/prohub/BillsCard";
import PensionCard from "@/components/prohub/PensionCard";
import GoalsCard from "@/components/prohub/GoalsCard";

export default function ProHub({ onBack }) {
  const [data, setData] = useState(null);
  const [failed, setFailed] = useState(false);

  const load = useCallback(() => {
    setFailed(false);
    return api.get("/pro-hub").then(({ data }) => setData(data)).catch(() => setFailed(true));
  }, []);
  useEffect(() => { load(); }, [load]);

  if (!data && failed) {
    return (
      <div data-testid="pro-hub-error" className="h-64 flex flex-col items-center justify-center gap-3 text-sm text-slate-400">
        Couldn't load your Professional Hub.
        <Button data-testid="pro-hub-retry" onClick={load} variant="outline" className="rounded-full border-[#00C896]/40 bg-transparent text-[#00C896] hover:bg-[#00C896]/10">Try again</Button>
      </div>
    );
  }
  if (!data) return <div className="h-64 flex items-center justify-center"><Loader2 className="h-7 w-7 animate-spin text-[#00C896]" /></div>;

  return (
    <div className="mm-fade-up" data-testid="pro-hub">
      <button data-testid="pro-back-button" onClick={onBack} className="inline-flex items-center gap-2 text-sm text-slate-400 hover:text-white transition-colors mb-5">
        <ArrowLeft className="h-4 w-4" /> Back to dashboard
      </button>
      <p className="text-[11px] font-semibold tracking-[0.2em] uppercase text-[#00C896]">Professional Hub</p>
      <h1 className="font-display text-3xl sm:text-4xl font-bold tracking-tight mt-1 flex items-center gap-2.5">
        <Briefcase className="h-8 w-8 text-[#00C896]" /> Make every payday go further
      </h1>
      <p className="text-slate-400 text-sm mt-2 max-w-xl">Plan your pay cycle, stay on top of bills and keep your pension and savings goals moving.</p>

      <div className="mt-6 grid grid-cols-12 gap-4 sm:gap-5">
        <div className="col-span-12 lg:col-span-7"><PaydayCard data={data} onChanged={load} /></div>
        <div className="col-span-12 lg:col-span-5"><PensionCard data={data} onChanged={load} /></div>
        <div className="col-span-12 lg:col-span-7"><BillsCard data={data} onChanged={load} /></div>
        <div className="col-span-12 lg:col-span-5"><GoalsCard data={data} onChanged={load} /></div>
      </div>
    </div>
  );
}
